import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { UCCOperParams, UCCOperTypes } from '../models'

export class UCCOperProvider extends AbstractProvider {
  urlPath = 'ucc_oper_api'

  public oper<T>(action: UCCOperTypes, params: Partial<UCCOperParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
    })

    return this.http.post(`${this.url}?${query}`, params)
  }
}
